var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256 64C149.969 64 64 149.961 64 256C64 362.039 149.969 448 256 448C291.891 448 325.438 438.164 354.156 421.051C355.141 420.465 356.172 419.996 357.234 419.637C358.062 419.355 358.922 419.145 359.781 419.004C360.938 418.812 362.125 418.75 363.297 418.82C364.594 418.898 365.875 419.133 367.141 419.531L443.547 443.543L419.531 367.145C418.172 362.797 418.719 358.07 421.047 354.156C438.172 325.445 448 291.895 448 256C448 149.961 362.031 64 256 64ZM32 256C32 132.289 132.281 32 256 32C379.719 32 480 132.289 480 256C480 295.227 469.906 332.141 452.156 364.234L478.672 448.574C484.484 467.082 467.078 484.484 448.578 478.668L364.234 452.16C332.141 469.902 295.234 480 256 480C132.281 480 32 379.711 32 256ZM272 232V352C272 356.133 270.438 359.902 267.859 362.742C265.625 365.219 262.609 366.988 259.203 367.68C258.172 367.891 257.094 368 256 368C251.359 368 247.188 366.031 244.266 362.887C241.625 360.031 240 356.203 240 352V232C240 223.164 247.156 216 256 216C264.844 216 272 223.164 272 232ZM256 192C269.25 192 280 181.254 280 168C280 158.684 274.688 150.605 266.938 146.629C263.656 144.949 259.938 144 256 144C242.75 144 232 154.746 232 168C232 181.254 242.75 192 256 192Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.20a9d3cf6708e83fbe588f1bcbec7081.svg";
export { ForwardRef as ReactComponent };